export default __webpack_public_path__ + "static/media/car_wash.9697244a.svg";